export default __webpack_public_path__ + "static/media/aws-marketplace-logo.e48e37e2.png";